import { captureSelectionIntentFromSearch } from './app/shared/warehouse-selection-intent';

captureSelectionIntentFromSearch(window.location.search);
import('./bootstrap').catch((error) => console.error(error));
